import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Email = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.41504 12.475C2.41504 12.475 2.41504 12.505 2.41504 12.525V37.505C2.41504 40.755 5.07504 43.415 8.33504 43.415H41.665C44.925 43.415 47.585 40.755 47.585 37.495V12.525C47.585 12.525 47.585 12.495 47.585 12.475C47.565 9.23496 44.915 6.58496 41.665 6.58496H8.33504C5.08504 6.58496 2.43504 9.22496 2.41504 12.475ZM6.05504 11.695C6.39504 10.765 7.28504 10.085 8.32504 10.085H41.665C42.705 10.085 43.605 10.755 43.935 11.695L24.995 24.955L6.05504 11.685V11.695ZM44.075 15.865V37.505C44.075 38.835 42.985 39.925 41.655 39.925H8.33504C7.00504 39.925 5.91504 38.835 5.91504 37.505V15.865L23.995 28.525C24.595 28.945 25.395 28.945 26.005 28.525L44.085 15.865H44.075Z"
        fill={color}
      />
    </svg>
  )
}
